export default axiosInstance => {
  async function query({ jwt }) {
    return (
      await axiosInstance({
        method: "get",
        url: "/liff/survey",
        headers: { jwt }
      })
    ).data;
  }

  async function create({ jwt, type, data }) {
    return (
      await axiosInstance({
        method: "post",
        url: "/liff/survey",
        headers: { jwt },
        data: { type, data }
      })
    ).data;
  }

  return {
    query,
    create
  };
};
